import moment from 'moment';

interface PolicyDates {
  startDate: string;
  endDate: string;
}

export const getPolicyDisplayDates = (policy: PolicyDates) => ({
  inception: moment(policy.startDate).format('DD/MM/YYYY'),
  expiry: moment(policy.endDate).format('DD/MM/YYYY'),
});

export const formatExtensionTimestamp = (date: string) => moment(date).format('DD/MM/YYYY HH:mm');

export const formatExtensionEndDate = (date: string) => moment(date).format('DD/MM/YYYY');
